import { MfaAdoptionReportRowModel } from 'src/app/hickory-api/model/models';

export interface MfaFactorsModel {
  mfaEnrolledFactors?: Array<string>;
  MfaEnrolledFactors?: Array<string>;
  factors?: Array<MfaAdoptionReportRowModel.FactorsEnum>;
}

export interface MfaFactorChip {
  label?: string;
  icon?: string;
}

export class MfaFactorsModelImpl {
  public static readonly NONE = 'Reports.MfaAdoption.Factor.None';
  public static readonly LOCALIZATION_PREFIX = 'Reports.MfaAdoption.Factor.';
  public static displayChips(model: MfaFactorsModel): MfaFactorChip[] {
    const factors = this.getFactors(model);
    if (factors?.length) {
      return factors.map(factor => ({
        label: this.mapFactor(factor),
        icon: this.mapFactorIcon(factor)
      }));
    }
    return [];
  }

  private static getFactors(model: MfaFactorsModel): string[] {
    const factorStrings = new Set<string>();
    (model?.mfaEnrolledFactors ?? []).forEach(f => factorStrings.add(f.toLowerCase()));
    (model?.MfaEnrolledFactors ?? []).forEach(f => factorStrings.add(f.toLowerCase()));
    (model?.factors ?? []).forEach(f => factorStrings.add(f.toString().toLowerCase()));
    return Array.from(factorStrings).filter(f => this.filterFactor(f));
  }

  private static filterFactor(factor: string): boolean {
    switch ((factor ?? '').toLowerCase()) {
      case 'totp': return true;
      case 'email': return true;
      default: return false;
    }
  }

  private static mapFactor(factor: string) {
    const prefix = this.LOCALIZATION_PREFIX;
    switch ((factor ?? '').toLowerCase()) {
      case 'totp': return `${prefix}Totp`;
      case 'email': return `${prefix}Email`;
      default: return null;
    }
  }

  private static mapFactorIcon(factor: string) {
    const key = (factor ?? '')
      .replace(this.LOCALIZATION_PREFIX, '')
      .toLowerCase();

    switch (key) {
      case 'totp': return 'smartphone';
      case 'email': return 'mail';
      default: return null;
    }
  }
}